/** Keys for state components register with `useScoutContext`. */
export const SCOUT_CONTEXT_KEYS = {
  DISCOVERY_SELECTION: 'discovery_selection',
  LISTS_SELECTION: 'lists_selection',
  STRATEGY_SELECTION: 'strategy_selection',
  PROFILE_STRATEGY_SELECTION: 'profile_strategy_selection',
  PROFILE_STRATEGY_MAP: 'profile_strategy_map',
  PROFILE_DRAWER: 'profile_drawer',
} as const;
